export default __webpack_public_path__ + "static/media/vardanMelkumyanResume.d65767b8.pdf";